interface State {
  stripe: boolean
  clinicChain: Record<string, {
    exclude: {
      suppliers: string[]
    }
  }>
}

export const useFeatureSettingsStore = defineStore('feature-settings', () => {
  const { baseURL } = useRuntimeConfig().app
  const userStore = useUserStore()

  const accessToken = computed(() => userStore.accessToken)
  const headerFields = computed(() => ({ Authorization: `Bearer ${unref(accessToken)}` }))
  const abortIfNotAuthenticated = useAbortIfNotAuthenticated()

  const {
    data: settings,
    pending: isFeatureSettingsDataPending,
    refresh: reloadFeatureSettingsData,
  } = useFetch<State>('/api/intern/feature-settings', {
    headers: headerFields,
    baseURL,
    watch: [accessToken],
    ...abortIfNotAuthenticated,
    onResponseError({ response }) {
      // Fire-and-forget: refreshing the token flips `accessToken`, and the
      // `watch: [accessToken]` above performs the single recovery refetch.
      if (response.status === 401) void userStore.reloadAuth()
    },
  })

  function $reset() {
    reloadFeatureSettingsData()
  }

  return {
    isFeatureSettingsDataPending,
    reloadFeatureSettingsData,
    $reset,
    settings,
  }
})
